
<div class="pie-chart">
    <svg class="pie-chart-background" viewBox="0 0 200 250" attr.data-blob-id="{{variant}}" fill-opacity="0.3">
        <path attr.d="{{backgroundPath}}" attr.fill="{{color}}">
            <animate 
                attributeName="d" 
                repeatCount="indefinite" 
                dur="50s" 
                attr.values="{{backgroundAnimatePath}}">
            </animate>
        </path>
    </svg>
    <svg viewBox="0 0 210 200" focusable="false">
        <g transform="translate(100, 100)">
            <g class="cluster" *ngFor="let cluster of dataCharts" (click)="emitEvent($event, cluster)" (keyup.enter)="emitEvent($event, cluster)" tabindex="0" role="link" aria-label="{{cluster.label.parts[0] + ' ' + cluster.label.parts[1]}}">
                <path attr.d="{{cluster['path']}}" attr.fill="{{color}}" fill-opacity="0.5">
                    <animate 
                        attr.attributeName="{{cluster['attributeName']}}" 
                        attr.repeatCount="{{cluster['repeatCount']}}" 
                        attr.dur="{{cluster['dur']}}" 
                        attr.values="{{cluster['animation']}}">
                    </animate>
                </path>
                <text class="pie-label" attr.x={{cluster.label.x}} attr.y={{cluster.label.y}} dominantBaseline="middle" textAnchor="middle">
                    <tspan attr.x={{cluster.label.x}} attr.y={{cluster.label.y}} dy=-4>
                        {{ cluster.label.parts[0] }}
                    </tspan>
                    <tspan *ngIf="cluster.label.parts.length > 1" attr.x={{cluster.label.x}} attr.y={{cluster.label.y}} dy=4>
                        {{ cluster.label.parts[1] }} 2
                    </tspan>
                </text>
            </g>
        </g>
    </svg>
</div>